import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#59ad3b",
      d: "M21 5c-3.232 0-5.892 2.591-6 5.799V17C14.38 13.282 8.917 6.372 3.003 5L3 9.59c.184 2.809 1.777 3.71 3.946 4.476 2.9 1.075 7.453 2.684 8.055 6.28-1.894-3.133-8.045-4.825-11.435-4.804a8.3 8.3 0 0 0 .887 2.07C5.618 19.517 7.718 21 10.002 21H14c2.283 0 4.383-1.483 5.548-3.387C20.581 15.925 20.947 13.762 21 11V5Zm-8.999-2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z"
    }, null, -1)
  ])))
}
export default { render: render }